/* ============================================================================
   ADMINISTRACIÓN DESDE EL NAVEGADOR

   Seis llamadas y una regla: **nunca lanzan**. Devuelven `{ ok, ... }` y el
   motivo tal como lo escribió el servidor, para que la pantalla lo muestre sin
   inventar un texto propio.

   ═══ POR QUÉ NO HAY UN `try` EN CADA PANTALLA ═══

   Una pantalla que llama a `fetch` directamente termina con un `catch` que dice
   «no se pudo» y pierde el 403, el 409 y el motivo en castellano que el
   servidor ya había preparado. Acá se conserva `estado` y `motivo`, y la
   pantalla decide qué hacer con ellos.
   ========================================================================== */

const BASE = "/api";

async function pedir(ruta, { metodo = "GET", cuerpo = null } = {}) {
    try {
        const respuesta = await fetch(`${BASE}${ruta}`, {
            method: metodo,
            credentials: "same-origin",
            headers: { "Content-Type": "application/json" },
            body: cuerpo === null ? undefined : JSON.stringify(cuerpo),
        });

        let datos = null;
        try { datos = await respuesta.json(); } catch { datos = null; }

        if (respuesta.ok) return { ok: true, estado: respuesta.status, datos };
        return {
            ok: false,
            estado: respuesta.status,
            motivo: datos?.error || "El servidor no pudo completar la operación.",
        };
    } catch {
        /* Sin red no es «no tienes permiso»: es «no hay con quién hablar». La
           pantalla lo dice así, y sigue mostrando lo último que tenía. */
        return {
            ok: false,
            estado: 0,
            motivo: "No se pudo hablar con el servidor. Revisa la conexión.",
        };
    }
}

export async function listarEmpresas() {
    const r = await pedir("/empresas");
    return r.ok ? { ok: true, empresas: r.datos?.empresas || [] } : r;
}

export async function crearEmpresa(nombre) {
    const r = await pedir("/empresas", { metodo: "POST", cuerpo: { nombre } });
    return r.ok ? { ok: true, empresa: r.datos?.empresa || null } : r;
}

export async function actualizarEmpresa(id, cambios) {
    const r = await pedir(`/empresas/${encodeURIComponent(id)}`, { metodo: "PATCH", cuerpo: cambios });
    return r.ok ? { ok: true, empresa: r.datos?.empresa || null } : r;
}

export async function listarUsuarios() {
    const r = await pedir("/usuarios");
    return r.ok ? { ok: true, usuarios: r.datos?.usuarios || [] } : r;
}

export async function crearUsuario(datos) {
    const r = await pedir("/usuarios", { metodo: "POST", cuerpo: datos });
    return r.ok ? { ok: true, usuario: r.datos?.usuario || null } : r;
}

export async function actualizarUsuario(id, cambios) {
    const r = await pedir(`/usuarios/${encodeURIComponent(id)}`, { metodo: "PATCH", cuerpo: cambios });
    return r.ok ? { ok: true, usuario: r.datos?.usuario || null } : r;
}
